module.exports = __webpack_public_path__ + "img/2.b8450453.svg";